import { c as _c } from "react/compiler-runtime";
import type { Entry, UnresolvedLink } from "contentful";
import CTAButtonPersonalized, { type CtaExposures } from "@/components/custom/CtaButton/CTAButtonPersonalized";
import { getEntryOfContentType } from "@/lib/contentful/guards";
import { cn } from "@/lib/utils";
import type { TypeButton, TypeButtonSkeleton, TypeExternalButton, TypeExternalButtonSkeleton } from "@/types/contentful/generated";
type ButtonLike = Entry<TypeButtonSkeleton | TypeExternalButtonSkeleton, undefined, string> | UnresolvedLink<"Entry">;
type ButtonEntry = TypeButton<undefined, string> | TypeExternalButton<undefined, string>;
type BackgroundType = "SG Blue" | "SG Gray" | "SG Red";
const BACKGROUND_CLASS: Record<BackgroundType, string> = {
  "SG Blue": "bg-[#3A6682] lg:bg-sg-blue",
  "SG Gray": "bg-[#4D4D4F] lg:bg-sg-gray",
  "SG Red": "bg-[#80241A] lg:bg-sg-red"
};
interface Props {
  heading?: string;
  bodyText?: string;
  cta?: ButtonLike[];
  ctaExposures?: CtaExposures;
  backgroundType: BackgroundType;
}
export default function CtaBanner(t0) {
  const $ = _c(21);
  const {
    heading,
    bodyText,
    cta,
    ctaExposures,
    backgroundType
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== backgroundType || $[1] !== bodyText || $[2] !== cta || $[3] !== ctaExposures || $[4] !== heading) {
    const buttons = (cta ?? []).map(_temp).filter(_temp2).slice(0, 2);
    t4 = "px-6 py-6 w-full max-w-site-content mx-auto";
    const t5 = BACKGROUND_CLASS[backgroundType];
    if ($[9] !== t5) {
      t1 = cn("flex flex-col items-center gap-12 rounded-md px-6 py-40 text-center", t5);
      $[9] = t5;
      $[10] = t1;
    } else {
      t1 = $[10];
    }
    if ($[11] !== bodyText || $[12] !== heading) {
      t2 = (heading || bodyText) && <div className="flex flex-col items-center gap-3 text-white">{heading && <h2 className="heading-xl tracking-[-0.02em] leading-[1.2]">{heading}</h2>}{bodyText && <p className="text-xl leading-[1.2]">{bodyText}</p>}</div>;
      $[11] = bodyText;
      $[12] = heading;
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    t3 = buttons.length > 0 && <div className="flex flex-col gap-4">{buttons.map(btn_0 => <CTAButtonPersonalized key={btn_0.sys.id} entry={btn_0} exposures={ctaExposures?.[btn_0.sys.id]} />)}</div>;
    $[0] = backgroundType;
    $[1] = bodyText;
    $[2] = cta;
    $[3] = ctaExposures;
    $[4] = heading;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t3) {
    t5 = <div className={t1}>{t2}{t3}</div>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <section className={t4}>{t5}</section>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}
function _temp2(b) {
  return b !== null;
}
function _temp(item) {
  const btn = getEntryOfContentType(item, "button");
  const ext = getEntryOfContentType(item, "externalButton");
  return btn ?? ext;
}